import { getSpaceOverviewRoute } from '@confluence/ssr-app/entry-points/routes.ts';

import { SpaceOverviewRouteComponent } from './SpaceOverviewRouteComponent.tsx';

export const SpaceOverviewRoute = getSpaceOverviewRoute(SpaceOverviewRouteComponent);
